import { render, staticRenderFns } from "./TypesOfTasks.vue?vue&type=template&id=49fc03f8"
import script from "./TypesOfTasks.vue?vue&type=script&lang=js"
export * from "./TypesOfTasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports